import { Component, ChangeDetectionStrategy } from '@angular/core';
import { InputComponent } from '../input/input.component';

@Component({
    selector: 'app-color',
    templateUrl: './color.component.html',
    styleUrls: ['./color.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ColorComponent extends InputComponent {
}
